import { render, staticRenderFns } from "./Popup.vue?vue&type=template&id=70ef6bee&scoped=true"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"
import style0 from "./Popup.vue?vue&type=style&index=0&id=70ef6bee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ef6bee",
  null
  
)

export default component.exports